<div class="landing-loader__badge" role="status" aria-label="Loading">
  <span class="landing-loader__ring"></span>
  <div class="landing-loader__medallion">
    <campaign-landing-gem class="landing-loader__gem" />
  </div>
</div>
<p class="landing-loader__eyebrow">Rewards · Points · Prizes</p>
